import { CE_VIEW_TEXT_VERSION_OPEN } from "@js/actions/studio/campaign_content_section/screen_view_text_version.js";

import { newScreen, getContent } from "@js/helpers/state.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_VIEW_TEXT_VERSION_OPEN: {
      let content = getContent(state, action.client_content_id);

      return newScreen(state, "view_text_version", {
        text: content.text,
      });
    }

    default:
      return state;
  }
};
